import 'select2';
import $ from 'jquery';

export default () => {
    $('.select2').select2({
        minimumResultsForSearch: -1,
    });
};
